export default "__VITE_ASSET__$26oZJ0p__"